import { USER_UPGRADE_CLEAR } from '@/constants/constants';
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  // MOVISTAR LITE ACTIVATION
  GET_MOVISTAR_LITE_STATUS_BEGINS: "GET_MOVISTAR_LITE_STATUS_BEGINS",
  GET_MOVISTAR_LITE_STATUS_SUCCESS: "GET_MOVISTAR_LITE_STATUS_SUCCESS",
  GET_MOVISTAR_LITE_STATUS_FAILURE: "GET_MOVISTAR_LITE_STATUS_FAILURE",

  GET_MOVISTAR_LITE_ACTIVATION_BEGINS: "GET_MOVISTAR_LITE_ACTIVATION_BEGINS",
  GET_MOVISTAR_LITE_ACTIVATION_SUCCESS: "GET_MOVISTAR_LITE_ACTIVATION_SUCCESS",
  GET_MOVISTAR_LITE_ACTIVATION_FAILURE: "GET_MOVISTAR_LITE_ACTIVATION_FAILURE",
  RESET_MOVISTAR_LITE_ACTIVATION: "RESET_MOVISTAR_LITE_ACTIVATION",

  GET_TV_PACKAGES_INFO_BEGINS: "GET_TV_PACKAGES_INFO_BEGINS",
  GET_TV_PACKAGES_INFO_SUCCESS: "GET_TV_PACKAGES_INFO_SUCCESS",
  GET_TV_PACKAGES_INFO_FAILURE: "GET_TV_PACKAGES_INFO_FAILURE",

  GET_MODULES_TV_BEGINS: "GET_MODULES_TV_BEGINS",
  GET_MODULES_TV_SUCCESS: "GET_MODULES_TV_SUCCESS",
};

export const actions = {
  /* MOVISTAR LITE ACTIVATION */
  getMovistarLiteStatus: () => ({
    type: types.GET_MOVISTAR_LITE_STATUS_BEGINS,
  }),
  successGetMovistarLiteStatus: (data) => ({
    type: types.GET_MOVISTAR_LITE_STATUS_SUCCESS,
    payload: data,
  }),
  failureGetMovistarLiteStatus: (error) => ({
    type: types.GET_MOVISTAR_LITE_STATUS_FAILURE,
    payload: error,
  }),
  getMovistarLiteActivation: (productId) => ({
    type: types.GET_MOVISTAR_LITE_ACTIVATION_BEGINS,
    payload: productId,
  }),
  successGetMovistarLiteActivation: (data) => ({
    type: types.GET_MOVISTAR_LITE_ACTIVATION_SUCCESS,
    payload: data,
  }),
  failureGetMovistarLiteActivation: (error) => ({
    type: types.GET_MOVISTAR_LITE_ACTIVATION_FAILURE,
    payload: error,
  }),
  resetMovistarLiteActivation: () => ({
    type: types.RESET_MOVISTAR_LITE_ACTIVATION,
  }),

  getTvPackagesInfo: (data) => ({
    type: types.GET_TV_PACKAGES_INFO_BEGINS,
    payload: data,
  }),
  succesGetTvPackagesInfo: (data) => ({
    type: types.GET_TV_PACKAGES_INFO_SUCCESS,
    payload: data,
  }),
  failureGetTvPackagesInfo: (data) => ({
    type: types.GET_TV_PACKAGES_INFO_FAILURE,
    payload: data,
  }),
  getModulesTv: (productId) => ({
    type: types.GET_MODULES_TV_BEGINS,
    productId
  }),
  setModulesTv: (data) => ({
    type: types.GET_MODULES_TV_SUCCESS,
    payload: data
  })
};

const initialState = {
  // movistar lite activation
  movistarLiteStatus: null,
  movistarLiteStatusFetching: false,
  movistarLiteStatusError: false,

  movistarLiteActivation: null,
  movistarLiteActivationFetching: false,
  movistarLiteActivationOrigin: null,
  movistarLiteActivationError: false,

  tvPackagesInfo: null,
  tvPackagesError: false,

  modules: null,
  modulesFecthed: false,
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { tv } = payload;
      return {
        ...state,
        ...tv,
      };
    }
    case USER_UPGRADE_CLEAR:
      return initialState;
    /* MOVISTAR-LITE */
    case types.GET_MOVISTAR_LITE_STATUS_BEGINS:
      return {
        ...state,
        movistarLiteStatus: null,
        movistarLiteStatusFetching: true,
        movistarLiteStatusFetched: false,
        movistarLiteStatusError: false,
      };
    case types.GET_MOVISTAR_LITE_STATUS_SUCCESS:
      return {
        ...state,
        movistarLiteStatus: payload,
        movistarLiteStatusFetching: false,
        movistarLiteStatusFetched: true,
        movistarLiteStatusError: false,
      };
    case types.GET_MOVISTAR_LITE_STATUS_FAILURE:
      return {
        ...state,
        movistarLiteStatus: null,
        movistarLiteStatusFetching: false,
        movistarLiteStatusFetched: true,
        movistarLiteStatusError: payload,
      };
    case types.GET_MOVISTAR_LITE_ACTIVATION_BEGINS:
      return {
        ...state,
        movistarLiteActivation: null,
        movistarLiteActivationOrigin: payload.origin,
        movistarLiteActivationFetching: true,
        movistarLiteActivationFetched: false,
        movistarLiteActivationError: false,
      };
    case types.GET_MOVISTAR_LITE_ACTIVATION_SUCCESS:
      return {
        ...state,
        movistarLiteActivation: payload,
        movistarLiteActivationFetching: false,
        movistarLiteActivationFetched: true,
        movistarLiteActivationError: false,
      };
    case types.GET_MOVISTAR_LITE_ACTIVATION_FAILURE:
      return {
        ...state,
        movistarLiteActivation: null,
        movistarLiteActivationFetching: false,
        movistarLiteActivationFetched: true,
        movistarLiteActivationError: payload,
      };
    case types.RESET_MOVISTAR_LITE_ACTIVATION:
      return {
        ...state,
        movistarLiteActivation: null,
        movistarLiteActivationOrigin: null,
        movistarLiteActivationFetching: false,
        movistarLiteActivationFetched: false,
        movistarLiteActivationError: false,
      };
    //GET TV_PACKAGES_INFO
    case types.GET_TV_PACKAGES_INFO_BEGINS:
      return {
        ...state,
      };
    case types.GET_TV_PACKAGES_INFO_SUCCESS:
      let newModule = {
        ...state.tvPackagesInfo,
      };
      newModule[payload.productId] = payload.data;
      return {
        ...state,
        tvPackagesInfo: newModule,
      };
    case types.GET_TV_PACKAGES_INFO_FAILURE:
      return {
        ...state,
        tvPackagesError: true,
      };
    case types.GET_MODULES_TV_BEGINS:
      return {
        ...state,
      }
    case types.GET_MODULES_TV_SUCCESS:
      return {
        ...state,
        modules: payload,
        modulesFecthed: true,
      }
    default:
      return state;
  }
}

export default reducer;
